// copy from src/components/discovery/store-locator/apis/google-geocoder.ts

export type GeocodeGeometry = {
  location: {
    lat: number,
    lng: number,
  }
}

type GeocodesResults = Array<{
  formatted_address: string,
  geometry: GeocodeGeometry,
  place_id: string
}>

type ReverseGeocodesResults = Array<{
  address_components: {long_name: string, short_name: string, types: string[]}[],
}>

export type Geocodes = {
  results: GeocodesResults,
  status: string,
}

export type ReverseGeocodes = {
  results: ReverseGeocodesResults,
  status: string,
}


export class GeocodesModel implements Geocodes {
  results: GeocodesResults = []
  status = ''
}

export class ReverseGeocodeModel implements ReverseGeocodes {
  results: ReverseGeocodesResults = []
  status = ''
}
